<div class="container-fluid-modal">


<form #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm(cat.value)" novalidate>

<div class="add" *ngIf="!editData">
    <div class="ModalHeader">
        <h4 mat-dialog-title>Add Store</h4>
        <div class="headerButton">
            <button type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
            </button>
            <button type="button" class="btn btn-warning"  matDialogClose (click)="close()"><i class="fa fa-times" aria-hidden="true" ></i> Cancel
            </button>
        </div>
    </div>

    <mat-dialog-content>
        <div class="card">
            <div class="card-body">
                    <div class="form-group col-lg-12">
                        <label for="City" class="labelRequired">City </label>
                        <select id="mySelect" data-show-content="true" class="form-control" placeholder="City"
                                [(ngModel)]="model.location_id" name="location_id" (change)="locationChange($event)" required #location_id="ngModel" [ngClass]= "{'has-danger' : cat?.submitted  && location_id?.invalid }">
                                <option disabled>Select City</option>
                                <option *ngFor="let data of locationsData" [value]="data?.id">
                                    {{data?.name}}
                                </option>
                        </select>
                        <div *ngIf="cat?.submitted && location_id?.invalid">
                                    <div [hidden]="!location_id.errors.required" class="formError"> * City Name is required </div>
                        </div>
                    </div>

                    <div class="form-group col-lg-12">
                        <label for="Warehouse" class="labelRequired">Antenna </label>
                        <select id="mySelect" data-show-content="true" class="form-control" placeholder="Antenna"
                                [(ngModel)]="model.antenna_id" name="antenna_id" required #antenna_id="ngModel" [ngClass]= "{'has-danger': cat?.submitted  && antenna_id?.invalid }">
                                <option disabled>Select Antenna</option>
                                <option *ngFor="let data of antennasData" [value]="data?.id">
                                    {{data?.name}}
                                </option>
		                        </select>
		                        <div *ngIf="cat?.submitted  && antenna_id?.invalid">
		                            <div [hidden]="!antenna_id.errors.required" class="formError"> * Antenna Name is required </div>
		                        </div>
                    </div>

                    <div class="form-group col-lg-12">
		                        <label for="Name" class="labelRequired">Name </label>
		                        <input type="text" name="name" class="form-control" placeholder="Store Name" #name="ngModel" [(ngModel)]="user.name" required [ngClass]= "{'has-danger': cat?.submitted  && name?.invalid }">
		                        <div *ngIf="cat?.submitted  && name?.invalid ">
		                                <div [hidden]="!name.errors.required" class="formError"> * Store Name is required </div>
		                        </div>
                    </div>
            </div>

        </div>

    </mat-dialog-content>
</div>

    <div class="edit" *ngIf= "editData">
                <div class="ModalHeader">
                    <h4 mat-dialog-title>Edit Store</h4>
                    <div class="headerButton">
                        <button *ngIf="editPermission" type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                        </button>
                        <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i
                                class="fa fa-times" aria-hidden="true"></i> Cancel
                        </button>
                    </div>
                </div>

                <mat-dialog-content>
                    <div class="card">
                        <div class="card-body">
                        <div class="form-group col-lg-12">
                        <label for="City" class="labelRequired">City </label>
                        <select id="mySelect" data-show-content="true" class="form-control" placeholder="City" [ngClass]="{'has-danger':cat?.submitted && location_id?.invalid }" [(ngModel)]="model.location_id" name="location_id" (change)="locationChange($event)" #location_id="ngModel" formnovalidate>
                                <option disabled>Select City</option>
                                <option *ngFor="let data of locationsData" [value]="data?.id">
                                    {{data?.name}}
                                </option>
                        </select>
                        <div *ngIf="cat?.submitted  && location_id?.invalid">
                            <div [hidden]="!location_id.errors.required" class="formError"> * Location Name is required </div>
                        </div>
                    </div>

                    <div class="form-group col-lg-12">
                        <label for="Warehouse" class="labelRequired">Antenna </label>
                        <select id="mySelect" data-show-content="true" class="form-control" placeholder="Antenna"
                                [(ngModel)]="model.antenna_id" name="antenna_id" formnovalidate>
                                <option disabled>Select Antenna</option>
                                <option *ngFor="let data of antennasData" [value]="data?.id">
                                    {{data?.name}}
                                </option>
                        </select>
                    </div>

                    <div class="form-group col-lg-12">
                        <label for="Store" class="labelRequired">Name </label>
                        <input type="text" class="form-control" placeholder="Store" name="name" [(ngModel)]="editData.name" required #name="ngModel" [ngClass]="{'has-danger':cat?.submitted && name?.invalid }">
                        <div *ngIf="cat?.submitted && name?.invalid">
                            <div [hidden]="!name.errors.required" class="formError"> * Store Name is required </div>
                        </div>
                    </div>

                        </div>

                    </div>

                </mat-dialog-content>
            </div>

    </form>
</div>
